var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3658 3.33447H3.25439V14.4478H14.3658V3.33447ZM13.0963 13.1764H4.52392V4.604H13.0963V13.1764Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0327 6.66797H6.58789V11.1137H11.0327V6.66797Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25439 36.6695H14.3658V25.5562H3.25439V36.6695ZM4.52392 26.8247H13.0963V35.3971H4.52392V26.8247Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0327 28.8896H6.58789V33.3344H11.0327V28.8896Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6343 3.33447V14.4478H36.7457V3.33447H25.6343ZM35.4771 13.1764H26.9038V4.604H35.4771V13.1764Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4135 6.66797H28.9678V11.1137H33.4135V6.66797Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2231 22.3812H30.3174V21.2326V18.9707V16.7088H20.8736V12.9784H24.0079V8.4536H20.8736V5.31836H16.3488V9.84217H19.4831V12.1822H16.3488V16.7088H13.7307H13.1745H9.2069V19.4869H5.95166V24.0088H10.4764V21.2326H13.1745V24.0088H17.6983V17.8574H19.4831V21.2326H24.8412V23.4945H28.9678V25.5565H22.5783V28.8507H19.4831V33.3736H24.0079V30.0812H28.9678V36.6698H36.7459V28.8898H30.3174V26.9079H36.7459V24.0088V22.3812V19.4869H32.2231V22.3812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintLabel);
export default __webpack_public_path__ + "static/media/printLabel.d5f4ccbf24c67617b6ee8f6008c0a581.svg";
export { ForwardRef as ReactComponent };